// extracted by mini-css-extract-plugin
export default {"circle-in":"CircularProgressWithLabel_circle-in__LwK17","box-content":"CircularProgressWithLabel_box-content__CyqOw"};